class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

    /* PB */
    this.autoClose = true;
    this.autoCloseTime = 2500;
    this.autoCloseTimeout = null;

    if (window.pb_animations) {
      if (
        (typeof window.pb_animations.useCartAutoClosing != 'undefined') && 
        window.pb_animations.useCartAutoClosing !== true && 
        window.pb_animations.useCartAutoClosing !== 1 && 
        window.pb_animations.useCartAutoClosing !== '1'
       ) {
         this.autoClose = false;
      }
      
      if (
        (typeof window.pb_animations.cartAutoClosingTime != 'undefined') && 
        window.pb_animations.cartAutoClosingTime !== null && 
        !isNaN(window.pb_animations.cartAutoClosingTime)
       ) {
         this.autoCloseTime = window.pb_animations.cartAutoClosingTime;
      }
    }
    /* /PB */
  }

  /* PB */
  connectedCallback() {
    this.cartDrawerUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (this.autoClose && event.source === 'cart-items' && (typeof event.cartItemsCount != 'undefined') && event.cartItemsCount === 0) {
        clearTimeout(this.autoCloseTimeout);
        this.autoCloseTimeout = setTimeout(() => {
          this.close();
        }, this.autoCloseTime);
  
        this.querySelector('.drawer__inner').addEventListener('mouseenter', () => {
          clearTimeout(this.autoCloseTimeout);
        });
  
        this.querySelector('.drawer__inner').addEventListener('touchstart', () => {
          clearTimeout(this.autoCloseTimeout);
        });
      }
    });
  }

  disconnectedCallback() {
    if (this.cartDrawerUpdateUnsubscriber) {
      this.cartDrawerUpdateUnsubscriber();
    }
  }
  /* PB */

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');

    /* PB */
   /* const drawer = this.querySelector('#CartDrawer.cart-drawer--just-added');

    if (drawer) {
      const justAddedNote = drawer.querySelector('.cart-item__just-added');
      const justAddedItem = drawer.querySelector('.cart-item--just-added');

      if (justAddedNote) {
        justAddedNote.remove();
      }

      if (justAddedItem) {
        justAddedItem.classList.remove('cart-item--just-added');
      }

      drawer.classList.remove('cart-drawer--just-added');
    }*/
    /* /PB */
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && 
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector 
        ? document.querySelector(section.selector) 
        : document.getElementById(section.id);

      /* PB */
      /*if (section.id == 'cart-drawer' && parsedState.product_id) {
        let defaultProcedure = false;
        const obtainedSectionElement = this.getObtainedSectionElement(parsedState.sections[section.id]);
        let cartDrawerElement = null, cartItemElement = null, cartItemDetailsElement = null;

        if (obtainedSectionElement) {
          cartDrawerElement = obtainedSectionElement.querySelector('#CartDrawer');
        } else {
          defaultProcedure = true;
        }

        if (cartDrawerElement) {
          cartItemElement = cartDrawerElement.querySelector('.cart-item[data-product-id="'+ parsedState.product_id +'"]');
        } else {
          defaultProcedure = true;
        }

        if (cartItemElement) {
          cartItemDetailsElement = cartItemElement.querySelector('.cart-item__details');
        } else {
          defaultProcedure = true;
        }

        if (cartItemDetailsElement) {
          let addedToBagString = 'Added to Bag';

          if (window.cartStrings && window.cartStrings.addedToBag) {
            addedToBagString = window.cartStrings.addedToBag;
          }

          cartItemDetailsElement.insertAdjacentHTML('afterbegin', '<div class="cart-item__just-added">'+ addedToBagString + '</div>');
          cartItemElement.classList.add('cart-item--just-added');
          sectionElement.classList.add('cart-drawer--just-added');
        } else {
          defaultProcedure = true;
        }

        if (defaultProcedure) {
          sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        } else {
          sectionElement.innerHTML = obtainedSectionElement.querySelector(section.selector).innerHTML;
        }
      } else {*/
      /* /PB */
        sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      /*}*/
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();

      /* PB */
      if (this.autoClose) {
        clearTimeout(this.autoCloseTimeout);
        this.autoCloseTimeout = setTimeout(() => {
          this.close();
        }, this.autoCloseTime);
  
        this.querySelector('.drawer__inner').addEventListener('mouseenter', () => {
          clearTimeout(this.autoCloseTimeout);
        });
  
        this.querySelector('.drawer__inner').addEventListener('touchstart', () => {
          clearTimeout(this.autoCloseTimeout);
        });
      }
      /* /PB */
    });
  }

  /* PB */
  getObtainedSectionElement(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }
  /* /PB */

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
